import { createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "iconn-holder" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-project-diagram" })
], -1)
const _hoisted_2 = { class: "sub-channel-wrap" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "sub-icon-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-comment" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("a", {
      href: "javascript:void(0)",
      class: "floating-anchor",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectToChannel(_ctx.activity)))
    }),
    _hoisted_1,
    _createVNode("h6", null, _toDisplayString(_ctx.activity.project_name), 1),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("p", null, _toDisplayString(_ctx.activity.name), 1)
    ])
  ], 64))
}